import React from "react";

const SubmitButton = ({
  title = "Submit",
  form,
  isDisabled = false,
  className = "button",
  submitting = false,
  ...other
}) => {
  if (submitting) {
    return (
      <button className={className}>
        <div className="loading-state loading-state--sm">
          <div className="loading loading--sm"></div>
        </div>
      </button>
    );
  }

  return (
    <button
      type="submit"
      form={form}
      className={`${className} ${isDisabled ? "button--disabled btn--disabled" : ""}`}
      disabled={isDisabled}
      {...other}
    >
      {title}
    </button>
  );
};

export default SubmitButton;
